import { Component, inject } from '@angular/core';
import { EnergySourceService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  EnergySourceCreateDto,
  EnergySourceDto,
  EnergySourceExcelDownloadDto,
  EnergySourceUpdateDto,
} from '../proxy/general/dtos/energy-source';
import { ENERGYSOURCE_CONFIG, ENERGYSOURCE_FIELDS } from './energy-source.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-energy-source',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, EnergySourceService, ConfirmationService],
  templateUrl: './energy-source.html',
  styleUrl: './energy-source.scss',
})
export class EnergySource extends BaseCrudComponent<
  EnergySourceDto,
  EnergySourceCreateDto,
  EnergySourceUpdateDto,
  EnergySourceExcelDownloadDto
> {
  service = inject(EnergySourceService);
  config = ENERGYSOURCE_CONFIG;
  fields = ENERGYSOURCE_FIELDS;

  protected prepareUpdateDto(data: any, selected: EnergySourceDto): EnergySourceUpdateDto {
    return {
      name: data.name,
      code: data.code,
      ducsaCode: data.ducsaCode,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'EnergySource';
  }
}
